import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { handleOnClickLogout } from "../constants";
import { NavBar, SideBar, Breadcrumb, Contacts_ } from "../components";
import { ToastContainer } from "react-toastify";

const Contacts = () => {
  const user = JSON.parse(localStorage.getItem("user_info"));
  const token = user.access_token;
  const email = user.email;
  const [breads, setBreads] = useState(["Contacts"]);

  const [loading, setLoading] = useState(false);

  const changeBreadCrumbs = (i) => {
    setBreads(breads.slice(0, i + 1));
  };

  const addBreadCrumb = (crumb) => {
    setBreads(["Contacts", crumb]);
  };

  const navigate = useNavigate();

  return (
    <div className="flex flex-col bg-white w-full h-screen overflow-hidden justify-start items-center text-secondary">
      <NavBar
        handleLogout={handleOnClickLogout}
        setLoading={setLoading}
        token={token}
      />
      <div className="flex flex-row w-full h-full">
        <SideBar active={"contacts"} />
        <div className="flex flex-col w-full h-full">
          <Breadcrumb breads={["Contacts"]} />
          <div className="flex flex-col w-full h-full justify-center items-center">
            <Contacts_ token={token} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contacts;
